// import { scan } from 'react-scan';
import '@ant-design/v5-patch-for-react-19'
import 'react-loading-skeleton/dist/skeleton.css'
import './i18n'
import './style.css'
import './scss/main.scss'

import { createRoot } from 'react-dom/client'

import App from './app'
import ScrollToTop from './components/ScrollToTop'
import { configureAmplify } from './config/amplify'
import ExternalFileScripts from './ExternalFileScripts'
import { AppProvider } from './providers'
import { handlePunchout } from './punchout-handle'

// scan({
//   enabled: true,
// });

configureAmplify()

// Check if this is a punchout URL that needs processing
const isPunchoutUrl = globalThis.location.pathname.includes('punchout')
  && !globalThis.location.pathname.includes('technical-login')

if (isPunchoutUrl) {
  handlePunchout()
} else {
  const container = document.querySelector('#root')
  if (!container) {
    throw new Error('Root element not found')
  }

  const root = createRoot(container)
  root.render(
    <AppProvider>
      <ExternalFileScripts />
      <ScrollToTop />
      <App />
    </AppProvider>,
  )
}
